import { ref } from 'vue'
import ApiService from '@/services/api.js'

export function useStatistics() {
  // Reactive state
  const statItems = ref([])
  const isLoadingData = ref(false)

  // Statistics yükleme
  const loadStatistics = async () => {
    try {
      console.log('🔄 Loading statistics data...')
      isLoadingData.value = true
      
      const statisticsData = await ApiService.getStatistics()
      console.log('📊 Statistics API response:', statisticsData)
      
      if (statisticsData && statisticsData.length > 0) {
        statItems.value = statisticsData.map(stat => ({
          value: parseInt(stat.value) || 0,
          suffix: stat.suffix || '',
          label_tr: stat.label_tr || stat.label,
          label_en: stat.label_en || stat.label,
          icon: stat.icon || 'fas fa-chart-line'
        }))
        console.log('✅ Statistics data loaded:', statItems.value.length, 'statistics')
        console.log('📊 First stat item:', statItems.value[0])
      } else {
        console.warn('⚠️ No statistics data received, using fallback')
        setFallbackStatistics()
      }
    } catch (error) {
      console.error('❌ İstatistikler yüklenemedi:', error)
      console.log('🔧 Using fallback statistics data')
      setFallbackStatistics()
    } finally {
      isLoadingData.value = false
    }
  }

  // Fallback statistics
  const setFallbackStatistics = () => {
    statItems.value = [
      {
        value: 150,
        suffix: '+',
        label_tr: 'Tamamlanan Proje',
        label_en: 'Completed Projects',
        icon: 'fas fa-project-diagram'
      },
      {
        value: 500,
        suffix: 'MW',
        label_tr: 'Kurulu Güç',
        label_en: 'Installed Capacity',
        icon: 'fas fa-bolt'
      },
      {
        value: 12,
        suffix: '+',
        label_tr: 'Yıllık Deneyim',
        label_en: 'Years Experience',
        icon: 'fas fa-calendar-alt'
      },
      {
        value: 95,
        suffix: '%',
        label_tr: 'Müşteri Memnuniyeti',
        label_en: 'Customer Satisfaction',
        icon: 'fas fa-smile'
      }
    ]
    console.log('🔧 Fallback statistics loaded:', statItems.value.length, 'items')
    console.log('🔧 First fallback item:', statItems.value[0])
  }

  // Initialize - statistics'i hemen yükle
  loadStatistics()

  return {
    statItems,
    isLoadingData,
    loadStatistics
  }
}